export * from './get-all-departments-axios'